<template>
	<div class="more_menu_wrap-desktop">
		<ul class="more_menu-desktop">
			<li v-for="(menu, menu_idx) in ['한국주식', '미국주식', '일본주식']" :key="menu_idx" class="menu">
				<router-link to="" class="menu_title_side" @click="onMenuClick(menu)">
					<div class="title_icon">
						<img v-if="menu === '한국주식'" src="@/assets/img/common/southkorea.svg" loading="lazy" alt="한국 국기" />
						<img v-else-if="menu === '미국주식'" src="@/assets/img/common/america.svg" loading="lazy" alt="미국 국기" />
						<img v-else src="@/assets/img/common/japan.svg" loading="lazy" alt="일본 국기" />
					</div>
					{{ menu }}
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script setup lang="ts">
import { onUnmounted } from 'vue';
import { useRouter } from 'vue-router';

import { useHeaderStore } from '@/stores/header';

// -----variable-----
const headerStore = useHeaderStore();
const router = useRouter();

// -----function-----
// 메뉴 클릭 시
const onMenuClick = (title: string) => {
	if (title === '한국주식') {
		headerStore.setCountry('KR');
		router.replace({ path: '/', query: {} });
	} else if (title === '미국주식') {
		headerStore.setCountry('USA');
		router.replace({ path: '/', query: {} });
	} else {
		headerStore.setCountry('JPN');
		router.replace({ path: '/', query: {} });
	}
};
// 스크롤 방지 기능 삭제
onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style scoped lang="scss">
.more_menu_wrap-desktop {
	position: absolute;
	top: 4.2rem;
	left: 1rem;
	z-index: 80;
}
.more_menu-desktop {
	background-color: var(--color-bg-mid);
	border-radius: var(--border-radius-small);
	box-shadow: 4px 4px 10px 0px #0000004d;
	.more_menu_title-desktop {
		display: flex;
		align-items: center;
		font-weight: var(--font-w-semi-bold);
		gap: var(--space-xx-small);
		padding: 1.85rem var(--space-large);
		.title_btn {
			img {
				width: 2.6rem;
				height: 2.6rem;
			}
		}
		.title_txt {
			font-size: var(--font-s-large);
		}
	}
	.menu_title_side {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0.8rem 1.2rem;
		gap: var(--space-x-small);
		font-weight: var(--font-w-light);
		font-size: var(--font-s-mid);
		line-height: 1.9rem;
		.title_icon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 2rem;
			height: 2rem;
			object-fit: contain;
			svg {
				width: 100%;
				height: 100%;
			}
		}
	}
}
</style>
